import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import CustomProgressIndicator from './CustomProgressIndicator';
import './style.scss';

export const StatisticsInteractiveMaterials = ({ totalCount, addedCount, title, subTitle, subTitleBottom, icon }) => {
  const { t } = useTranslation();

  return (
    <div className="statistics-interactive-materials-block">
      <div className="statistics-interactive-materials-block-top">
        <div className="statistics-interactive-materials-text">
          <span className="statistics-interactive-materials-count">
            {totalCount} {title}
          </span>
          <span className="statistics-interactive-materials-count-text">{t(subTitle)}</span>
        </div>
      </div>

      {totalCount > 1 && addedCount > 0 && <CustomProgressIndicator total={totalCount} completed={addedCount} />}

      {totalCount < 1 || (addedCount === 0 && <CustomProgressIndicator total={1} completed={0} />)}

      {totalCount === 1 || (addedCount === 0 && <CustomProgressIndicator total={0} completed={0} />)}

      <div className="statistics-interactive-materials-block-bottom">
        <div className="statistics-interactive-materials-info">
          <div className="block-interactive-icon">
            <img src={icon} alt="icon" />
          </div>

          <div className="statistics-interactive-materials-text">
            <span className="statistics-interactive-materials-count">
              {addedCount} {title}
            </span>
            <span className="statistics-interactive-materials-count-text">{t(subTitleBottom)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
